import { useCallback, useState } from 'react';
import { createElement, type ReactNode } from 'react';
import CompanyDuplicateErrorModal, {
  type ExistingOrganizationInfo,
} from '../components/modals/CompanyDuplicateErrorModal';
import { extractApiError } from '../lib/organizations';

export interface UseCompanyDuplicateModalResult {
  handleError: (err: unknown) => boolean;
  modalNode: ReactNode;
}

/**
 * ORGANIZATION_DUPLICATE_COMPANY 에러 처리 훅.
 * 에러를 감지하면 모달을 열고 true를 반환, 그 외 에러는 false.
 *
 * 결정 기록: docs/decisions/2026-04-18-company-org-scoped-model.md
 */
export function useCompanyDuplicateModal(): UseCompanyDuplicateModalResult {
  const [isOpen, setOpen] = useState(false);
  const [existingOrg, setExistingOrg] =
    useState<ExistingOrganizationInfo | null>(null);

  const handleError = useCallback((err: unknown): boolean => {
    const apiError = extractApiError(err);
    if (apiError.code === 'ORGANIZATION_DUPLICATE_COMPANY') {
      const existing =
        (apiError.details as { existingOrganization?: ExistingOrganizationInfo })
          ?.existingOrganization ?? null;
      setExistingOrg(existing);
      setOpen(true);
      return true;
    }
    return false;
  }, []);

  const modalNode = createElement(CompanyDuplicateErrorModal, {
    isOpen,
    onClose: () => setOpen(false),
    existingOrganization: existingOrg,
  });

  return { handleError, modalNode };
}
